module.exports = __webpack_public_path__ + "img/ral6022.b106d676.png";